<ng-template #uploadPopup>
  <button class="close close-button" (click)="cancelUploadPopup()" mat-button
    [disabled]="isUploading || showProcessing">
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Uploading File</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>

  <div style="margin: 20px 20px; cursor: not-allowed;">

    <ng-container *ngIf="isUploading">
      <div class="wrapper">
        <div class="progress-bar" [style.width.%]="uploadPercent"></div>
      </div>

      <div class="upload-status">
        <span>{{uploadPercent}} %</span>

        <span>{{uploadSpeed}} MB/s</span>

        <span>{{remainingTime}} remaining</span>
      </div>

      <div class="additional-info">
        {{uploadedSize}} MB of {{totalSize}} MB uploaded &nbsp;&nbsp; ({{remainingSize}} MB remaining)
      </div>
    </ng-container>

    <ng-container *ngIf="showProcessing">
      <div class="message-wrapper">
        <span style="color: var(--primary);">Processing...</span>
      </div>
    </ng-container>

    <ng-container *ngIf="!isUploading && !showProcessing">
      <div class="message-wrapper">
        <ng-container *ngIf="response?.resultType === 'S'; else no">
          <span style="color: green;">Uploaded Successfully</span>
        </ng-container>
        <ng-template #no>
          <span style="color: red;">Upload Failure</span>
        </ng-template>
      </div>
    </ng-container>

  </div>
</ng-template>

<ng-template #multipleUploadPopup>

  <button class="close close-button" (click)="cancelUploadPopup()" mat-button
    [disabled]="disableCloseButton(uploadQueue)"
    [matTooltip]="disableCloseButton(uploadQueue) ? 'Cannot close while uploading': ''">
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="app" class="popupTitle">Uploading Files</label>
    <label for="app" class="popupAppTitle">One<span style="color:gold;">QMS</span></label>
  </div>

  <div class="multi-uploader-wrapper">

    <div *ngFor="let item of uploadQueue; trackBy: trackByFile" class="upload-item">

      <div><b>{{ item.file.name }}</b></div>

      <div class="wrapper">
        <div class="progress-bar" [style.width.%]="item.progress"></div>
      </div>

      <div class="upload-status">
        <span>{{item.progress}} %</span>
        <span *ngIf="item.progress > 0 && item.progress < 100">{{item.speed}} MB/s</span>
        <span *ngIf="item.progress > 0 && item.progress < 100">{{item.remainingTime}}</span>
      </div>

      <div class="additional-info">
        {{item.uploadedSize}} / {{item.totalSize}} MB
      </div>
      <div class="message-wrapper"
        style="display: flex; justify-content: space-between; align-items: center; margin-top: 8px;">

        <!-- LEFT SIDE: STATUS -->
        <div>

          <span *ngIf="item.status === 'uploading'" style="color: var(--primary)">
            Uploading...
          </span>

          <span *ngIf="item.status === 'pending'" style="color: var(--primary)">
            In Queue...
          </span>

          <span *ngIf="item.status === 'success'" style="color: green">
            <img src="../../assets/img/accessSymbol.svg" alt="success" width="20"> Success
          </span>

          <span *ngIf="item.status === 'error'" style="color: red">
            <img src="../../assets/img/noAcessSymbol.svg" alt="failure" width="20"> {{item.message}}
          </span>

          <span *ngIf="item.status === 'cancelled'" style="color: rgb(155, 103, 5)">
            ⚠ Cancelled
          </span>

        </div>

        <!-- RIGHT SIDE: BUTTON -->
        <div>

          <button mat-stroked-button class="cancelButton" *ngIf="item.status === 'uploading'"
            (click)="cancelUpload(item)">
            Cancel
          </button>

          <button mat-stroked-button class="cancelButton" *ngIf="item.status === 'error' || item.status === 'cancelled'"
            (click)="retryUpload(item)">
            Retry
          </button>

        </div>

      </div>

    </div>

  </div>

</ng-template>
